"use client";

import { lazy } from "react";
import type { ToolUIMeta, ToolUIRegistry } from "../../tool-renderer";

export const databricksToolRegistry = {
  databricksListCatalogs: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./views").then(({ DatabricksListCatalogsToolView }) => ({
        default: DatabricksListCatalogsToolView,
      }))
    ),
  },
  databricksListSchemas: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./views").then(({ DatabricksListSchemasToolView }) => ({
        default: DatabricksListSchemasToolView,
      }))
    ),
  },
  databricksListTables: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./views").then(({ DatabricksListTablesToolView }) => ({
        default: DatabricksListTablesToolView,
      }))
    ),
  },
  databricksExecuteSql: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./execute-sql").then(({ DatabricksExecuteSqlToolView }) => ({
        default: DatabricksExecuteSqlToolView,
      }))
    ),
  },
  databricksDescribeTable: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./views").then(({ DatabricksDescribeTableToolView }) => ({
        default: DatabricksDescribeTableToolView,
      }))
    ),
  },
  databricksListFunctions: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./views").then(({ DatabricksListFunctionsToolView }) => ({
        default: DatabricksListFunctionsToolView,
      }))
    ),
  },
  databricksGetPermissions: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./views").then(({ DatabricksGetPermissionsToolView }) => ({
        default: DatabricksGetPermissionsToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;

/**
 * Namespaced variant of `databricksToolRegistry` keyed by the
 * progressive-disclosure inner-tool name `databricks_${toolName}`.
 *
 * Databricks is a progressive-disclosure capability (ADR-057 / ADR-113), so
 * its tool calls are dispatched through the `callCapabilityTool` proxy and
 * every durable + live-stream tool part is rewritten to the namespaced inner
 * identity (e.g. `databricks_databricksExecuteSql`). The bare-name entries
 * above stay in the static tier (still required by `AllToolNames` and used by
 * chats persisted before the move); these entries reuse the same lazy views so
 * the SQL result table keeps rendering on the PD path. Wired into the dynamic
 * tier in `packages/sdk/react/src/tools/built-in-registry.ts`.
 */
export const databricksProgressiveDisclosureToolRegistry: Record<
  string,
  ToolUIMeta
> = Object.fromEntries(
  Object.entries(databricksToolRegistry).map(([name, meta]) => [
    `databricks_${name}`,
    meta,
  ])
);
